// Only doctors (admin_type_id = 2) have special routing/UI behaviour.
// All other admin types use the default staff flow and privilege-based access.
export const DOCTOR_TYPE_ID = 2;

export const isDoctor = (adminTypeId) =>
  Number(adminTypeId) === DOCTOR_TYPE_ID;
